import { Observable } from "@hibas123/utils";

export enum Pages {
   Library,
   Stats,
   Reader,
   Add,
   Details,
   Browse,
   Edit,
}

export default class Navigation {
   private static _page: Pages = Pages.Library;
   private static pageObservableServer = new Observable<{
      page: Pages;
      state: any;
   }>();
   public static pageObservable = Navigation.pageObservableServer.getPublicApi();
   private static _state: any;
   public static get state() {
      return Navigation._state;
   }
   public static setPage(page: Pages, state: any) {
      // console.log("Set page:", page);
      if (
         Navigation.page !== page ||
         JSON.stringify(state) !== JSON.stringify(Navigation.state)
      ) {
         Navigation._state = state;
         Navigation._page = page;
         let s = "";
         if (state) {
            s = "&state=" + encodeURIComponent(JSON.stringify(state));
         }
         let newhash = "#" + Pages[page] + s;
         if (window.location.hash !== newhash)
            window.history.pushState({}, document.title, newhash);
         this.pageObservableServer.send({ page, state });
      } else {
         // console.log("Skipping page change!")
      }
   }

   static get page() {
      return this._page;
   }

   static onHashChange() {
      let hash = window.location.hash.substring(1);
      if (hash && hash !== "") {
         let [page, state] = hash.split("&state=");
         if (page && Number(page) !== Number.NaN) {
            let p = Pages[page];
            if (!p) p = Pages.Library;
            let s = undefined;
            if (state) {
               try {
                  s = JSON.parse(decodeURIComponent(state));
               } catch (err) {
                  s = undefined;
                  console.error(err);
               }
            }
            Navigation.setPage(p, s);
         }
      } else {
         Navigation.setPage(Pages.Library, undefined);
      }
   }
}
window.onhashchange = () => {
   Navigation.onHashChange();
};
Navigation.onHashChange();
